<template>
  <div class="home">
    <topNav></topNav>
    <div class="ind_video">
      <div class="title" v-if="videoUrl">
        <div class="conent1">LEVERAGE</div>
        <div class="conent2"><span style="color: #fff;">MULTIMODAL</span> GAME VISUAL UNDERSTANDING</div>
        <div class="conent3">TO DELIVER MORE ENGAGING GAMING CONTENT</div>
        <!-- <div class="conent3">AI GEN GAMING COMMUNITY</div> -->
      </div>
      <video width="100%" height="auto" :src="videoUrl" id="myVideo" controls disablepictureinpicture="" autoplay="true"
        loop="" muted ref="videoPlayer" @mouseenter="playVideo" @click="clickplayVideo"></video>
    </div>
    <div class="ind_ban pc">
      <img src="@/assets/img/homeban1.png" />
      <img src="@/assets/img/homeban2.png" />
      <img src="@/assets/img/homeban3.png" />
    </div>
    <div class="ind_ban mob">
      <img src="@/assets/img/homeban_mb1.png" />
      <img src="@/assets/img/homeban_mb2.png" />
      <img src="@/assets/img/homeban_mb3.png" />
    </div>
    <bottomNav></bottomNav>
    <!-- <div class="aiImg" @click="goRouter('/ai')"><img src="@/assets/img/ai.png" alt="" ></div> -->
    <ai v-if="false" />

  </div>
</template>

<script>
// @ is an alias to /src
import { config } from '@/api/user'
import bottomNav from '@/components/bottomNav.vue'
import topNav from '@/components/topNav.vue'
import ai from '@/components/ai.vue'
export default {
  name: 'HomeView',
  components: {
    topNav,
    bottomNav,
    ai,
  },
  data() {
    return {
      videoUrl: ''
    }
  },
  mounted() {

    this.getInfo();
    window.addEventListener('scroll', this.updateScrollTop);
  },
  methods: {
    async getInfo() {
      let res = await config({});
      console.log('res12', res);
      this.videoUrl = res.data.site_home_video;
    },
    playVideo() {
      const video = this.$refs.videoPlayer;
      var that = this;
      if (video.paused) {
        video.play().catch(error => {
          // console.error('1111Auto play failed:', error);
        });
      }
    },
    updateScrollTop() {
      // this.playVideo();
    },
    clickplayVideo() {
      const myVideo = document.getElementById('myVideo');
      myVideo.play();
    }


  }
}
</script>
<style scoped lang="scss">
@font-face {
  font-family: zdyfont;
  font-weight: normal;
  font-style: normal;
  // font-family: zdyfont;
  src: url('https://baiyelianmeng.xinzhiyukeji.cn/static/wximage/zdyfont.ttf') format('truetype');
}

@font-face {
  font-family: YourFont;
  font-weight: normal;
  font-style: normal;
  src: url('/src/assets/aaa.TTF') format('truetype');
}

.title {
  position: absolute;
  left: 90px;
  top: 270px;
  font-size: 40px;
  color: #fff;
  font-weight: 700;
  font-family: 'YourFont';

  .conent2 {
    // margin-left: 20px;
    margin-top: 80px;
    color: #73beff;
  }

  .conent3 {
    // margin-left: 40px;
    margin-top: 80px;
  }
}

@media screen and (max-width: 1200px) {
  .title {
    left: 50px;
    top: 200px;
    font-size: 30px;

    .conent2 {
      margin-top: 20px;
    }

    .conent3 {
      margin-top: 20px;
    }
  }
}

@media screen and (max-width: 750px) {
  .title {
    left: 20px;
    top: 100px;
    font-size: 20px;

    .conent2 {
      margin-top: 10px;
    }

    .conent3 {
      margin-top: 10px;
    }
  }
}
</style>
